import React, {useEffect, useState } from 'react'
import './Clients.css'
import './Datagrid.css'
import Box from '@mui/material/Box';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';

import { faRefresh } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';

import ActionButtons from './ActionButtons';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';



function Clients() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const columns = [
    { field: 'id', headerName: 'ID', type: 'number', width: 60, cellClassName: "dataGrid__cell__center" },
    {
      field: 'name',
      headerName: 'Client',       
      cellClassName: "dataGrid__cell",
      flex: 0.5,
      minWidth: 120
    },
    {
      field: 'projects',
      headerName: 'Projects',     
      cellClassName: "dataGrid__cell",
      flex: 0.5,
      minWidth: 120
    },
    {
      field: 'actions',
      headerName: 'Actions',   
      cellClassName: "dataGrid__cell",
      width: 100,
      type: 'actions',
      renderCell: params => <ActionButtons { ...{params, handleClickDelete, handleClickOpen}}/>
    }
  ];

  const {token, apiURL} = useAuth();
  const getClients = async () => {
    setIsLoading(true);
    const payload = {
      
    }
  
    axios.get(`${apiURL}/api/clients`, payload)
      .then(response => {                
        setClients(response.data.data);        
        setIsLoading(false);
      })
  }
  const [clients, setClients] = useState([]);

  useEffect(() => {
    getClients();

  }, [])

  const [open, setOpen] = React.useState(false);
  const [targetId, setTargetId] = useState(null);

  const handleClickDelete = (id) => {
    setOpen(true);
    setTargetId(id);
  };

  const handleClickOpen = (id) => {
      console.log(id)
      navigate(`/clients/${id}`);
  }

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    if(!targetId) return;
    axios.delete(`${apiURL}/api/clients/${targetId}`)
      .then(response => {                
        setClients(clients.filter(item => { return(item.id != targetId) }))
        setOpen(false);
        setTargetId(null);
      })
  };

  const addNew = () => {
    navigate("/clients/new")
  }
  const refetch = () => {
    getClients();
  }

  return (
    <>
    <div className="content-heading">
      <div>Clients
        <small>Manage clients</small>
      </div>
      <div className="ml-auto">
        <button className='btn btn-sm btn-success' onClick={addNew}>Add</button> <button className='btn btn-sm btn-primary' onClick={refetch}><FontAwesomeIcon icon={faRefresh} /> Refresh</button>
      </div>
    </div>
    

        <Box  className="clients__box" sx={{ height: 720, width: '100%' }}>
          <DataGrid
            rows={clients}
            columns={columns}
            pageSize={50}
            rowsPerPageOptions={[50]}
            rowHeight={30}

            components={{ Toolbar: GridToolbar }}
            
            /*checkboxSelection*/
            /*disableSelectionOnClick*/
            /*experimentalFeatures={{ newEditingApi: true }}*/
            
          />
        </Box>
        <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm deleting client"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this client?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>No</Button>
          <Button onClick={handleDelete} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
        {isLoading ? (<div className='loading'><span>Loading...</span></div>) : <></>}
    
    </>
  )
}

export default Clients